// extracted by mini-css-extract-plugin
module.exports = {"body":"ShopsBlock_body__2dHOJ"};